var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1582 8.67197L16.1311 3.77856L28.8589 9.04913",
    fill: "#FF583E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2826 30.3489C26.4721 30.3489 28.2469 28.767 28.2469 26.8156C28.2469 24.8642 26.4721 23.2822 24.2826 23.2822C22.0932 23.2822 20.3184 24.8642 20.3184 26.8156C20.3184 28.767 22.0932 30.3489 24.2826 30.3489Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3256 30.3489C14.515 30.3489 16.2899 28.767 16.2899 26.8156C16.2899 24.8642 14.515 23.2822 12.3256 23.2822C10.1362 23.2822 8.36133 24.8642 8.36133 26.8156C8.36133 28.767 10.1362 30.3489 12.3256 30.3489Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34512 9.61338L6.74011 2.74633H0V0.911133H8.21807L11.2953 9.02556L9.34512 9.61338Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34961 8.07251H32.9397L27.4902 21.6999H9.11067L4.34961 8.07251Z",
    fill: "#FFD67F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCart);
export default __webpack_public_path__ + "static/media/Product_Cart.11a11e6ce241451b596c239a6f9164d7.svg";
export { ForwardRef as ReactComponent };